import Mock from "./mock";

const photo = require("../assets/placeholders/photo.jpg");
const logotype = require("../assets/placeholders/logotype.png");
const icon = require("../assets/placeholders/icon.svg");
const blog = require("../assets/bg/blog.jpeg");
const event = require("../assets/bg/event.jpg");
const startup = require("../assets/bg/startup.jpeg");
const team = require("../assets/bg/team.jpeg");
const impacticon = require("../assets/icons/support.svg");
const resilience = require("../assets/icons/resiliance.svg");
const skills = require("../assets/icons/skills.svg");

const database = {
  categories: [
    {
      id: "0",
      title: "Startups",
    },
    {
      id: "1",
      title: "Strategies",
    },
    {
      id: "2",
      title: "Entrepreneur",
    },
    {
      id: "3",
      title: "Corporate Sector",
    },
  ],
  choose: {
    list: [
      {
        icon: icon,
        text:
          "Phosfluorescently re-engineer frictionless metrics via premier niches. Seamlessly cultivate high-quality niches whereas empowered processes",
      },
      {
        icon: icon,
        text:
          "Seamlessly grow enabled scenarios without viral channels. Appropriately actualize stand-alone benefits and viral imperatives",
      },
      {
        icon: icon,
        text:
          "Monotonectally benchmark robust leadership skills before high standards in vortals. Collaboratively productivate business.",
      },
    ],
  },
  facts: [
    {
      text:
        "Globally leverage existing error-free models and B2B products. Professionally productize interdependent.",
      title: "Believe in your business skills but never stop improving",
    },
    {
      text:
        "Globally leverage existing error-free models and B2B products. Professionally productize interdependent.",
      title:
        "Efficiently impact focused e-services vis-a-vis client-focused outsourcing",
    },
    {
      text:
        "Globally leverage existing error-free models and B2B products. Professionally productize interdependent.",
      title:
        "Enthusiastically supply client-centered alignments after prospective",
    },
    {
      text:
        "Globally leverage existing error-free models and B2B products. Professionally productize interdependent.",
      title:
        "Professionally disintermediate client-focused intellectual capital ",
    },
    {
      text:
        "Globally leverage existing error-free models and B2B products. Professionally productize interdependent.",
      title: "Compellingly matrix global products before 2.0 technologies",
    },
  ],
  facts2: [
    {
      icon: icon,
      lead: "Projects done",
      text:
        "Rapidiously foster goal-oriented supply chains via error-free mindshare integrate flexible.",
      title: 417,
    },
    {
      icon: icon,
      lead: "Positive feedback",
      text:
        "Rapidiously foster goal-oriented supply chains via error-free mindshare integrate flexible.",
      title: "87%",
    },
    {
      icon: icon,
      lead: "Hours worked",
      text:
        "Rapidiously foster goal-oriented supply chains via error-free mindshare integrate flexible.",
      title: "1.8k",
    },
  ],
  fast_links: [
    {
      title: "Homepage",
      url: "/home",
    },
    {
      title: "Startups",
      url: "/startups",
    },
    {
      title: "Team",
      url: "/team",
    },
    {
      title: "Events",
      url: "events",
    },
    {
      title: "Blogs",
      url: "blogs",
    },
  ],
  features: [
    {
      src: "https://drive.google.com/uc?id=1ZsqsAE9gEphhVjzhDt07KdoMGv8Z3BnD",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=1CKnky_5MjCCwBjzCYFcYKLfczTmJVvzX",
      width: 1,
      height: 1
    },
    {
      src: "https://drive.google.com/uc?id=1QhXAVU1lCYn7VkKai4eyJhbPV0xeUpTe",
      width: 3,
      height: 4
    },
    {
      src: "https://drive.google.com/uc?id=1BSouHJSf_zRH7gr40an4P-0y1t_two4_",
      width: 3,
      height: 4
    },
    // {
    //   src: "https://drive.google.com/uc?id=1s0X1ddQGgEs0M7jx3izQSZbz499KvI_G",
    //   width: 2,
    //   height: 3
    // },
    {
      src: "https://drive.google.com/uc?id=1PERRp9yQ7TIeEr0x3LcK-GOqc8ONLLGk",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=17wyO0-9sQFsC64a1PoX1_gYo6xR20GH1",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=121ihgJtFGed-6SJPSmHk4JTss5IqRKIg",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=1lsY75y-eO-WW0PzKcIUC-Bx6s7e1e4Xc",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=1PmcElvTYls3u5CFqWOw9xBjBEimxJzC_",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=18F1vZXHcHUCRjjHXZWQnSUe9aelZNggg",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=1ksyoVvSO831HmmIog7SpIPL1xVGx69Lj",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=1bdp5WBXg23S8N5NmTJnM8HvAyk3d0Gkd",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=1Z6CrhAY4fGst5jinTlTRftHjQq-L2h22",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=1Y2yQ5BfB7kR32M_GIY4vFMJiC8fZOdaq",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=12S5ZvvWK79v2LCX3-lKzl745dhBUc-PO",
      width: 3,
      height: 4
    },
    {
      src: "https://drive.google.com/uc?id=1sWF5tpKx5srrBc3btqskZ942mMMBKElK",
      width: 3,
      height: 4
    },
    {
      src: "https://drive.google.com/uc?id=1Z7F1tnw99EI0qeT0uptOBuGe-0m2cC79",
      width: 4,
      height: 3
    },
    {
      src: "https://drive.google.com/uc?id=1y1JqcaGSKikrroUZ5pzBNXQ21_eguFQs",
      width: 4,
      height: 3
    },
  ],
  features2: [
    {
      image: impacticon,
      text:
        "With its action, Ruminate attempts to create a positive impact on the startup ecosystem. The parent organization already has some startups on board and many more in the conceptual stage. The cell has been a source of inspiration for budding entrepreneurs and aims to continue the leaner but meaner legacy.",
      title: "#1 Impact",
    },
    {
      image: resilience,
      text:
        "Ruminate has focused on the technical aspects of entrepreneurship but a lot on the humanitarian side. There have been sincere efforts from Ruminate in the past to keep the momentum going inside and outside the cell. It has been successful in connecting future entrepreneurs to the torchbearers and the veterans.",
      title: "#2 Resilience",
    },
    {
      image: skills,
      text:
        "When it comes to creating the best results with the minimal scope of error, we nail it. Our members have been delivering exceptional results beating unforeseen challenges. We are determined to be a proactive part of the ecosystem and ready to mesmerize the world with our innovative ideas and deeds.",
      title: "#3 Competence",
    },
  ],
  header_bgs: {
    about: startup,
    about_video_poster: photo,
    blog: blog,
    contacts: photo,
    contacts_w: photo,
    portfolio: photo,
    services: team,
    team: photo,
    team_w: photo,
    facts: photo,
    subscribe: photo,
    list: photo,
  },
  menu: [
    {
      // children: [
      //   {
      //     name: "Slider Header",
      //     url: "/",
      //   },
      //   {
      //     name: "Paralax Image",
      //     url: "/home-paralax",
      //   },
      //   {
      //     name: "Video Background",
      //     url: "/home-video",
      //   },
      // ],
      name: "Home",
      url: "/",
    },
    {
      name: "Startups",
      url: "/startups",
    },
    {
      name: "Team",
      url: "/team",
    },
    {
      name: "Events",
      url: "/events",
    },
    {
      // children: [
      //   {
      //     name: "Grid Left Sidebar",
      //     url: "/blog-grid-left-sidebar",
      //   },
      //   {
      //     name: "List Left Sidebar",
      //     url: "/blog-list-left-sidebar",
      //   },
      //   {
      //     name: "Grid Right Sidebar",
      //     url: "/blog-grid-right-sidebar",
      //   },
      //   {
      //     name: "List Right Sidebar",
      //     url: "/blog-list-right-sidebar",
      //   },
      //   {
      //     name: "Grid No Sidebar",
      //     url: "blog-grid-without-sidebar",
      //   },
      // ],
      name: "Blogs",
      url: "/blogs",
    },
    // {
    //   name: "Contacts",
    //   url: "/contacts",
    // },
  ],
  partners: [logotype, logotype, logotype, logotype, logotype, logotype],
  portfolio: [
    {
      cats: "contracting management construction",
      clientid: "0",
      feedback:
        "Rapidiously transform end-to-end strategic theme areas through functional information. Enthusiastically engage pandemic systems rather than installed base manufactured products. Quickly promote market positioning bandwidth before transparent sources.",
      full:
        "Dramatically provide access to customer directed platforms before professional portals. Objectively foster revolutionary human capital for error-free materials. Quickly envisioneer prospective alignments and distributed best practices. Quickly empower ethical users with 24/7 experiences. Interactively myocardinate go forward alignments whereas high standards in data.<br> Synergistically benchmark clicks-and-mortar collaboration and idea-sharing before stand-alone products. Rapidiously simplify inexpensive process improvements via go forward value. Collaboratively e-enable bricks-and-clicks markets without web-enabled meta-services. Dramatically re-engineer state of the art e-business after cooperative internal or organic sources. Energistically iterate corporate outsourcing for visionary results.",
      id: 0,
      img: photo,
      lead: "Construction",
      memberid: 0,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Modern materials ecology safety",
    },
    {
      cats: "construction management contracting",
      clientid: "1",
      feedback:
        "Compellingly content architect backward-compatible models and quality communities. Professionally drive wireless benefits whereas orthogonal internal sources. Completely negotiate an expanded array of metrics and extensible interfaces.",
      full:
        "Phosfluorescently reconceptualize exceptional total linkage without holistic e-tailers. Objectively utilize functional e-tailers rather than economically sound infomediaries. Uniquely expedite user friendly communities and 24/365 leadership. Objectively enhance plug-and-play relationships vis-a-vis dynamic outside the box thinking.<br>Energistically cultivate reliable data without standardized mindshare. Holisticly incubate progressive process improvements with just in time niche markets. Collaboratively brand interactive quality vectors after virtual expertise. Globally harness progressive action items whereas revolutionary collaboration and idea-sharing. Quickly facilitate real-time data without client-focused communities.",
      id: 1,
      img: photo,
      lead: "Manufacture",
      memberid: 1,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Architecture design in a wood village",
    },
    {
      cats: "contracting construction",
      clientid: "2",
      feedback:
        'Rapidiously syndicate professional e-services without wireless "outside the box" thinking. Distinctively seize proactive leadership via B2B alignments. Progressively myocardinate long-term high-impact manufactured products.',
      full:
        "Rapidiously leverage other's inexpensive leadership whereas cross-media outside the box thinking. Competently e-enable global interfaces after interdependent outside the box thinking. Competently brand timely expertise rather than inexpensive internal or organic sources. Continually scale high-quality niches before high-payoff resources. Professionally drive turnkey infomediaries for high standards in initiatives.<br> Enthusiastically facilitate front-end convergence with client-centered opportunities. Dynamically evolve compelling applications rather than pandemic partnerships. Uniquely cultivate goal-oriented information without cross-platform channels. Energistically customize B2B sources via distinctive leadership. Professionally initiate client-centered metrics without client-focused interfaces.",
      id: 2,
      img: photo,
      lead: "Engeneering",
      memberid: 2,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Effective house system for country side",
    },
    {
      cats: "management contracting",
      clientid: "3",
      feedback:
        'Rapidiously syndicate professional e-services without wireless "outside the box" thinking. Distinctively seize proactive leadership via B2B alignments. Progressively myocardinate long-term high-impact manufactured products.',
      full:
        "Dramatically provide access to customer directed platforms before professional portals. Objectively foster revolutionary human capital for error-free materials. Quickly envisioneer prospective alignments and distributed best practices. Quickly empower ethical users with 24/7 experiences. Interactively myocardinate go forward alignments whereas high standards in data.<br> Synergistically benchmark clicks-and-mortar collaboration and idea-sharing before stand-alone products. Rapidiously simplify inexpensive process improvements via go forward value. Collaboratively e-enable bricks-and-clicks markets without web-enabled meta-services. Dramatically re-engineer state of the art e-business after cooperative internal or organic sources. Energistically iterate corporate outsourcing for visionary results.",
      id: 3,
      img: photo,
      lead: "Construction",
      memberid: 0,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Workers equipment from first-grades",
    },
    {
      cats: "construction",
      clientid: "1",
      feedback:
        "Compellingly content architect backward-compatible models and quality communities. Professionally drive wireless benefits whereas orthogonal internal sources. Completely negotiate an expanded array of metrics and extensible interfaces.",
      full:
        "Phosfluorescently reconceptualize exceptional total linkage without holistic e-tailers. Objectively utilize functional e-tailers rather than economically sound infomediaries. Uniquely expedite user friendly communities and 24/365 leadership. Objectively enhance plug-and-play relationships vis-a-vis dynamic outside the box thinking.<br>Energistically cultivate reliable data without standardized mindshare. Holisticly incubate progressive process improvements with just in time niche markets. Collaboratively brand interactive quality vectors after virtual expertise. Globally harness progressive action items whereas revolutionary collaboration and idea-sharing. Quickly facilitate real-time data without client-focused communities.",
      id: 4,
      img: photo,
      lead: "Manufacture",
      memberid: 1,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "When city become architecture miracle",
    },
    {
      cats: "construction management",
      clientid: "0",
      feedback:
        'Rapidiously syndicate professional e-services without wireless "outside the box" thinking. Distinctively seize proactive leadership via B2B alignments. Progressively myocardinate long-term high-impact manufactured products.',
      full:
        "Rapidiously leverage other's inexpensive leadership whereas cross-media outside the box thinking. Competently e-enable global interfaces after interdependent outside the box thinking. Competently brand timely expertise rather than inexpensive internal or organic sources. Continually scale high-quality niches before high-payoff resources. Professionally drive turnkey infomediaries for high standards in initiatives.<br> Enthusiastically facilitate front-end convergence with client-centered opportunities. Dynamically evolve compelling applications rather than pandemic partnerships. Uniquely cultivate goal-oriented information without cross-platform channels. Energistically customize B2B sources via distinctive leadership. Professionally initiate client-centered metrics without client-focused interfaces.",
      id: 5,
      img: photo,
      lead: "Engeneering",
      memberid: 2,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Systems in every project completion",
    },
    {
      cats: "construction contracting",
      clientid: "2",
      feedback:
        'Rapidiously syndicate professional e-services without wireless "outside the box" thinking. Distinctively seize proactive leadership via B2B alignments. Progressively myocardinate long-term high-impact manufactured products.',
      full:
        "Dramatically provide access to customer directed platforms before professional portals. Objectively foster revolutionary human capital for error-free materials. Quickly envisioneer prospective alignments and distributed best practices. Quickly empower ethical users with 24/7 experiences. Interactively myocardinate go forward alignments whereas high standards in data.<br> Synergistically benchmark clicks-and-mortar collaboration and idea-sharing before stand-alone products. Rapidiously simplify inexpensive process improvements via go forward value. Collaboratively e-enable bricks-and-clicks markets without web-enabled meta-services. Dramatically re-engineer state of the art e-business after cooperative internal or organic sources. Energistically iterate corporate outsourcing for visionary results.",
      id: 6,
      img: photo,
      lead: "Construction",
      memberid: 0,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Complete project for city statement",
    },
    {
      cats: "management",
      clientid: "3",
      feedback:
        "Compellingly content architect backward-compatible models and quality communities. Professionally drive wireless benefits whereas orthogonal internal sources. Completely negotiate an expanded array of metrics and extensible interfaces.",
      full:
        "Phosfluorescently reconceptualize exceptional total linkage without holistic e-tailers. Objectively utilize functional e-tailers rather than economically sound infomediaries. Uniquely expedite user friendly communities and 24/365 leadership. Objectively enhance plug-and-play relationships vis-a-vis dynamic outside the box thinking.<br>Energistically cultivate reliable data without standardized mindshare. Holisticly incubate progressive process improvements with just in time niche markets. Collaboratively brand interactive quality vectors after virtual expertise. Globally harness progressive action items whereas revolutionary collaboration and idea-sharing. Quickly facilitate real-time data without client-focused communities.",
      id: 7,
      img: photo,
      lead: "Manufacture",
      memberid: 1,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Stay on a bay compromise state",
    },
    {
      cats: "management contracting",
      clientid: "0",
      feedback:
        "Compellingly content architect backward-compatible models and quality communities. Professionally drive wireless benefits whereas orthogonal internal sources. Completely negotiate an expanded array of metrics and extensible interfaces.",
      full:
        "Rapidiously leverage other's inexpensive leadership whereas cross-media outside the box thinking. Competently e-enable global interfaces after interdependent outside the box thinking. Competently brand timely expertise rather than inexpensive internal or organic sources. Continually scale high-quality niches before high-payoff resources. Professionally drive turnkey infomediaries for high standards in initiatives.<br> Enthusiastically facilitate front-end convergence with client-centered opportunities. Dynamically evolve compelling applications rather than pandemic partnerships. Uniquely cultivate goal-oriented information without cross-platform channels. Energistically customize B2B sources via distinctive leadership. Professionally initiate client-centered metrics without client-focused interfaces.",
      id: 8,
      img: photo,
      lead: "Engeneering",
      memberid: 2,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Strong link with nature wildreness",
    },
    {
      cats: "construction management",
      clientid: "2",
      feedback:
        'Rapidiously syndicate professional e-services without wireless "outside the box" thinking. Distinctively seize proactive leadership via B2B alignments. Progressively myocardinate long-term high-impact manufactured products.',
      full:
        "Dramatically provide access to customer directed platforms before professional portals. Objectively foster revolutionary human capital for error-free materials. Quickly envisioneer prospective alignments and distributed best practices. Quickly empower ethical users with 24/7 experiences. Interactively myocardinate go forward alignments whereas high standards in data.<br> Synergistically benchmark clicks-and-mortar collaboration and idea-sharing before stand-alone products. Rapidiously simplify inexpensive process improvements via go forward value. Collaboratively e-enable bricks-and-clicks markets without web-enabled meta-services. Dramatically re-engineer state of the art e-business after cooperative internal or organic sources. Energistically iterate corporate outsourcing for visionary results.",
      id: 9,
      img: photo,
      lead: "Construction",
      memberid: 0,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Future of construction in life",
    },
    {
      cats: "contracting construction",
      clientid: "3",
      feedback:
        "Compellingly content architect backward-compatible models and quality communities. Professionally drive wireless benefits whereas orthogonal internal sources. Completely negotiate an expanded array of metrics and extensible interfaces.",
      full:
        "Phosfluorescently reconceptualize exceptional total linkage without holistic e-tailers. Objectively utilize functional e-tailers rather than economically sound infomediaries. Uniquely expedite user friendly communities and 24/365 leadership. Objectively enhance plug-and-play relationships vis-a-vis dynamic outside the box thinking.<br>Energistically cultivate reliable data without standardized mindshare. Holisticly incubate progressive process improvements with just in time niche markets. Collaboratively brand interactive quality vectors after virtual expertise. Globally harness progressive action items whereas revolutionary collaboration and idea-sharing. Quickly facilitate real-time data without client-focused communities.",
      id: 10,
      img: photo,
      lead: "Manufacture",
      memberid: 1,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Most ambitious project in history",
    },
    {
      cats: "contracting",
      clientid: "0",
      feedback:
        'Rapidiously syndicate professional e-services without wireless "outside the box" thinking. Distinctively seize proactive leadership via B2B alignments. Progressively myocardinate long-term high-impact manufactured products.',
      full:
        "Rapidiously leverage other's inexpensive leadership whereas cross-media outside the box thinking. Competently e-enable global interfaces after interdependent outside the box thinking. Competently brand timely expertise rather than inexpensive internal or organic sources. Continually scale high-quality niches before high-payoff resources. Professionally drive turnkey infomediaries for high standards in initiatives.<br> Enthusiastically facilitate front-end convergence with client-centered opportunities. Dynamically evolve compelling applications rather than pandemic partnerships. Uniquely cultivate goal-oriented information without cross-platform channels. Energistically customize B2B sources via distinctive leadership. Professionally initiate client-centered metrics without client-focused interfaces.",
      id: 11,
      img: photo,
      lead: "Engeneering",
      memberid: 2,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Skyscraper for modern city company",
    },
    {
      cats: "management",
      clientid: "3",
      feedback:
        "Compellingly content architect backward-compatible models and quality communities. Professionally drive wireless benefits whereas orthogonal internal sources. Completely negotiate an expanded array of metrics and extensible interfaces.",
      full:
        "Phosfluorescently reconceptualize exceptional total linkage without holistic e-tailers. Objectively utilize functional e-tailers rather than economically sound infomediaries. Uniquely expedite user friendly communities and 24/365 leadership. Objectively enhance plug-and-play relationships vis-a-vis dynamic outside the box thinking.<br>Energistically cultivate reliable data without standardized mindshare. Holisticly incubate progressive process improvements with just in time niche markets. Collaboratively brand interactive quality vectors after virtual expertise. Globally harness progressive action items whereas revolutionary collaboration and idea-sharing. Quickly facilitate real-time data without client-focused communities.",
      id: 12,
      img: photo,
      lead: "Manufacture",
      memberid: 0,
      stats: [
        {
          icon: "las la-users-cog",
          text: "Peoples at project",
          title: "17",
        },
        {
          icon: "las la-calendar-alt",
          text: "Days to completion",
          title: "141",
        },
        {
          icon: "las la-coffee",
          text: "Cups of coffee",
          title: "480",
        },
        {
          icon: "las la-comments",
          text: "Positive feedbacks",
          title: "700+",
        },
      ],
      text:
        "Dynamically provide access to cutting-edge infomediaries whereas 24/7 collaboration and idea-sharing. ",
      title: "Green project with investors",
    },
  ],

  posts: [
    {
      category_id: 0,
      featured: true,
      full:
        "All businesses succeed by solving real problems, but most people have no idea where to start. How do you pick the products or services you’ll turn into your problem-solving enterprises?<p>Here’s an idea I can roughly guarantee: Look at the work you’ve done in the past. Where were the choke points? What were problems people avoided because of the work you did?<p>No matter how you spent the first part of your life and career, you’ve learned to be good at something. It can be anything from gardening in small spaces to designing fire safety systems. We all have a specialty. This doesn’t mean you have to be the world’s authority on a subject; it just means you can talk competently about solving problems in that niche of the world.<p>The goal of your startup’s marketing efforts will be to find a sufficient number of people who are interested in that niche and then to connect with that community in ways that are valuable to them. You don’t want to market to everyone — you want to market to the folks who respect the value of the knowledge you have on a focused topic.",
      id: "post_0",
      image: "https://assets.entrepreneur.com/content/3x2/2000/20200304224058-GettyImages-1084174168.jpeg?width=700&crop=2:1",
      posting_date: "Apr 2, 2020",
      link: "https://www.entrepreneur.com/article/347157",
      quote: "",
      // quote:
      //   "Ski slopes are marked by difficulty. The green circle indicates the easiest slope, the one that will get you to the base of the hill the fastest, with the least amount of risk or drama. ",
      short:
        "All businesses succeed by solving real problems, but most people have no idea where to start. How do you pick the products or services you’ll turn into your problem-solving enterprises?",
      title: "Starting a Business That People Need ",
      user_id: "4",
    },
    {
      category_id: 3,
      featured: true,
      full:
        "It is commonly said that opposites attract, it is a physical law applicable in the corporate and entrepreneurship world , corporations find the commitment, risk orientation and adaptability of startups attractive. Innovation, technology and flexibility are attributes of entrepreneurs, and in contrast, companies offer marketing channels, strategic alliances, contacts with investors and the experience to achieve business expansion and scalability.<p>The pilots are a gateway, the way to test the operation of a solution within the corporation, that is, the first date, which can determine the dynamics and life of the alliance. Both corporations and startups seek sustainable and scalable collaborations , where both parties benefit, to achieve this, five determining factors must be considered:<p>1. Understanding the problem<p>It is important to establish the criticality of the problem that the startup is going to solve and to know the needs in a real way. The answer to the following questions allows us to see if we are facing an alliance with a promising future: Is the solution related to the core of the business? Is it transversal to different areas? Does it generate efficiency or representative savings? and creates added value?",
      id: "post_1",
      image: "https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcTOvyKIieHPoUqeGhaOawvaExikbAQloXDOmHfrw7CuSIb8_g",
      posting_date: "Mar 23, 2021",
      quote: "",
      link: "https://www.entrepreneur.com/article/367681",
      // "dolor dolores doloribus ducimus fuga iusto magni maiores minus nam numquam officiis provident quasi",
      short:
        "It is commonly said that opposites attract, it is a physical law applicable in the corporate and entrepreneurship world , corporations find the commitment, risk orientation and adaptability of startups attractive. Innovation, technology and flexibility are attributes of entrepreneurs, and in contrast, companies offer marketing channels, strategic alliances, contacts with investors and the experience to achieve business expansion and scalability.",
      title: "5 determining factors for a successful relationship between startups and corporations",
      user_id: "3",
    },
    {
      category_id: 1,
      featured: true,
      full:
        "If you are a startup, from the early stages you should be considering having various strategies that allow you to move your company forward, understand the market they want to penetrate, know how they are going to enter and how you are going to reach your customers. With that, the consulting firm G2, a firm specializing in startups, gives you the following recommendations:<p>Entrepreneur: Entrepreneur is an American magazine and website that carries news stories about entrepreneurship, small business management, and business. The magazine was first published in 1977. It is published by Entrepreneur Media Inc., headquartered in Irvine, California.",
      id: "post_2",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKCCegc5Ck6dXTBiTCTuX5KUaPzN9vvSd0v6TRrqVZrUH87A",
      link: "https://www.entrepreneur.com/article/367838",
      posting_date: "Mar 24, 2021",
      quote:
        "Keeping a startup afloat is challenging, but it doesn't have to be, if you remember these principles. ",
      short:
        "If you are a startup, from the early stages you should be considering having various strategies that allow you to move your company forward, understand the market they want to penetrate, know how they are going to enter and how you are going to reach your customers. With that, the consulting firm G2, a firm specializing in startups, gives you the following recommendations:",
      title: "Startups Looking to Sustain Their Growth Should Keep These 3 Strategies in Mind",
      user_id: "1",
    },
    {
      category_id: 2,
      featured: true,
      full:
        "Skills, knowledge and experience all come into play when you’re defining yourself as an entrepreneur and growing your company. But you also need to think about your image. In your personal brand, in meetings with clients, in pitches to investors and even when talking to your team, you’ll need to learn how to project confidence if you’re going to succeed.But how exactly can you do it?<p> The value of confidence<p>Confidence can improve your abilities and results as an entrepreneur in many different ways, including:  First impressions. You know that first impressions are important. Within a few seconds of meeting someone for the first time, they’ll start to form a picture of you. Projecting confidence can seal that image as a competent and experienced one — and help you establish authority and respect in any situation.  ",
      id: "post_3",
      image: "https://assets.entrepreneur.com/content/3x2/2000/1621286593-GettyImages-1164230517.jpg?width=400&crop=3:2",
      posting_date: "May 25, 2021",
      link: "https://www.entrepreneur.com/article/371193",
      // quote:
      //   "dolor dolores doloribus ducimus fuga iusto magni maiores minus nam numquam officiis provident quasi",
      short:
        "In your personal brand, in meetings with clients, in pitches to investors and even when talking to your team, you'll need to learn how to project confidence if you're going to succeed. But how exactly can you do it?",
      title: "How to Project Confidence as an Entrepreneur",
      user_id: "5",
    },
    {
      category_id: 0,
      full:
        "There’s an essential, intangible something in start-ups—an energy, a soul. It inspires enthusiasm and fosters a sense of deep connection and mutual purpose.<p> While this spirit persists, engagement is high and businesses keep their edge.But all too often, companies lose their souls as they mature. Firms add new systems and structures and bring in experienced professionals—and in the process somehow crush their original energizing spirit. In research into more than a dozen fast-growth ventures and 200-plus interviews with founders and executives, the author has discovered how firms can overcome this problem. His work shows that there are three crucial dimensions to a start-up’s soul: business intent, or a loftier reason for being; unusually close customer connections; and an employee experience characterized by autonomy and creativity—by “voice” and “choice.” All three provide meaning to stakeholders.",
      id: "post_4",
      image: "https://hbr.org/resources/images/article_assets/2019/06/R1904E_DOHERTY.jpg",
      posting_date: "July, 2019",
      link: "https://hbr.org/2019/07/the-soul-of-a-start-up",
      quote:
        "Most founders believe their start-ups are about more than their business models.",
      short:
        "There’s an essential, intangible something in start-ups—an energy, a soul. It inspires enthusiasm and fosters a sense of deep connection and mutual purpose. While this spirit persists, engagement is high and businesses keep their edge.",
      title: "The Soul of a Start-Up",
      user_id: "0",
    },
    {
      category_id: 1,
      full:
        "Longevity in business creation is taken as a given – nobody sets out to create a company with an expiration date. That said, very few early-stage companies think critically about the strategic principles needed to endure. We think this is essential going forward.<p>Looking at long-standing companies across various industries, we were able to identify several foundational elements that have contributed to these companies’ tenures. They include society-first principles, adaptable long-term strategies, and scalable leadership. By adopting such standards, startups can increase the odds of long-term sustainability without negatively impacting short-term growth or society at large.<p>Articulate a value framework oriented toward societal impact, not just financial achievement.",
      id: "post_5",
      image: "https://hbr.org/resources/images/article_assets/2019/07/Jul19_08-968634122.jpg",
      link: "https://hbr.org/2019/07/building-a-startup-that-will-last",
      posting_date: "",
      quote:
        "In a marathon, pacing and perseverance are paramount.",
      short:
        "Few companies from the tech boom of the mid-2000s had the foresight to temper their pace in anticipation of the long journey that lay ahead. Our collective obsession with disruption made us look at decades-old companies as something to dismantle rather than admire. The potential for career-defining gains got the best of many investors and advisors, and we failed to coach founders on the fundamentals of sustainability.",
      title: "Building a Startup That Will Last",
      user_id: "2",
    },

    // {
    //   category_id: 0,
    //   full:
    //     "Dynamically enhance distributed scenarios rather than extensive metrics. Compellingly supply leveraged leadership and standardized web-readiness. Phosfluorescently predominate competitive platforms after unique potentialities. Seamlessly engineer optimal niches through turnkey communities. Objectively grow emerging alignments before sticky synergy. <p> Enthusiastically e-enable inexpensive expertise for low-risk high-yield e-commerce. Monotonectally facilitate cutting-edge communities vis-a-vis process-centric systems. Competently utilize granular infomediaries with team building e-commerce. Seamlessly enable market positioning action items through optimal collaboration and idea-sharing. Dramatically revolutionize cross functional opportunities before multifunctional interfaces.<p> Uniquely pontificate e-business materials rather than seamless benefits. Completely coordinate client-centric channels for 24/365 communities. Quickly facilitate covalent interfaces after prospective vortals. Monotonectally envisioneer competitive collaboration and idea-sharing and plug-and-play systems. Energistically syndicate leading-edge initiatives vis-a-vis wireless materials. Completely initiate unique benefits via corporate core competencies. Holisticly maximize highly efficient channels without world-class partnerships. <p>Phosfluorescently brand stand-alone deliverables via premier infrastructures. Enthusiastically visualize scalable applications via market positioning web services. Phosfluorescently redefine high standards in models before emerging leadership. Energistically morph user-centric mindshare with 24/7 niches. Uniquely strategize resource maximizing outsourcing without cross functional ROI. Globally productize process-centric solutions rather than focused sources. Monotonectally repurpose bleeding-edge ideas via extensible human capital. <p>Collaboratively orchestrate covalent platforms rather than just in time infrastructures. Collaboratively expedite plug-and-play web services without professional ideas. Synergistically provide access to open-source markets with covalent methodologies. Dynamically develop multimedia based meta-services vis-a-vis an expanded array of infrastructures. Professionally supply ubiquitous initiatives whereas cross-platform users. Phosfluorescently restore superior solutions with error-free customer service.",
    //   id: "post_7",
    //   image: photo,
    //   posting_date: "Feb 07, 2020",
    //   quote:
    //     "dolor dolores doloribus ducimus fuga iusto magni maiores minus nam numquam officiis provident quasi",
    //   short:
    //     "Objectively streamline magnetic leadership skills vis-a-vis an expanded array of paradigms appropriately incentivize adaptive.",
    //   title: "To afford luxury life always work hard",
    //   user_id: "3",
    // },
    // {
    //   category_id: 1,
    //   full:
    //     "Dynamically enhance distributed scenarios rather than extensive metrics. Compellingly supply leveraged leadership and standardized web-readiness. Phosfluorescently predominate competitive platforms after unique potentialities. Seamlessly engineer optimal niches through turnkey communities. Objectively grow emerging alignments before sticky synergy. <p> Enthusiastically e-enable inexpensive expertise for low-risk high-yield e-commerce. Monotonectally facilitate cutting-edge communities vis-a-vis process-centric systems. Competently utilize granular infomediaries with team building e-commerce. Seamlessly enable market positioning action items through optimal collaboration and idea-sharing. Dramatically revolutionize cross functional opportunities before multifunctional interfaces.<p> Uniquely pontificate e-business materials rather than seamless benefits. Completely coordinate client-centric channels for 24/365 communities. Quickly facilitate covalent interfaces after prospective vortals. Monotonectally envisioneer competitive collaboration and idea-sharing and plug-and-play systems. Energistically syndicate leading-edge initiatives vis-a-vis wireless materials. Completely initiate unique benefits via corporate core competencies. Holisticly maximize highly efficient channels without world-class partnerships. <p>Phosfluorescently brand stand-alone deliverables via premier infrastructures. Enthusiastically visualize scalable applications via market positioning web services. Phosfluorescently redefine high standards in models before emerging leadership. Energistically morph user-centric mindshare with 24/7 niches. Uniquely strategize resource maximizing outsourcing without cross functional ROI. Globally productize process-centric solutions rather than focused sources. Monotonectally repurpose bleeding-edge ideas via extensible human capital. <p>Collaboratively orchestrate covalent platforms rather than just in time infrastructures. Collaboratively expedite plug-and-play web services without professional ideas. Synergistically provide access to open-source markets with covalent methodologies. Dynamically develop multimedia based meta-services vis-a-vis an expanded array of infrastructures. Professionally supply ubiquitous initiatives whereas cross-platform users. Phosfluorescently restore superior solutions with error-free customer service.",
    //   id: "post_8",
    //   image: photo,
    //   posting_date: "Feb 06, 2020",
    //   quote:
    //     "dolor dolores doloribus ducimus fuga iusto magni maiores minus nam numquam officiis provident quasi",
    //   short:
    //     "Happiness is the universal feeling we all aspire to experience more of, yet, we can be an angry, moody",
    //   title: "Start you working process with tools",
    //   user_id: "0",
    // },
    // {
    //   category_id: 2,
    //   full:
    //     "Dynamically enhance distributed scenarios rather than extensive metrics. Compellingly supply leveraged leadership and standardized web-readiness. Phosfluorescently predominate competitive platforms after unique potentialities. Seamlessly engineer optimal niches through turnkey communities. Objectively grow emerging alignments before sticky synergy. <p> Enthusiastically e-enable inexpensive expertise for low-risk high-yield e-commerce. Monotonectally facilitate cutting-edge communities vis-a-vis process-centric systems. Competently utilize granular infomediaries with team building e-commerce. Seamlessly enable market positioning action items through optimal collaboration and idea-sharing. Dramatically revolutionize cross functional opportunities before multifunctional interfaces.<p> Uniquely pontificate e-business materials rather than seamless benefits. Completely coordinate client-centric channels for 24/365 communities. Quickly facilitate covalent interfaces after prospective vortals. Monotonectally envisioneer competitive collaboration and idea-sharing and plug-and-play systems. Energistically syndicate leading-edge initiatives vis-a-vis wireless materials. Completely initiate unique benefits via corporate core competencies. Holisticly maximize highly efficient channels without world-class partnerships. <p>Phosfluorescently brand stand-alone deliverables via premier infrastructures. Enthusiastically visualize scalable applications via market positioning web services. Phosfluorescently redefine high standards in models before emerging leadership. Energistically morph user-centric mindshare with 24/7 niches. Uniquely strategize resource maximizing outsourcing without cross functional ROI. Globally productize process-centric solutions rather than focused sources. Monotonectally repurpose bleeding-edge ideas via extensible human capital. <p>Collaboratively orchestrate covalent platforms rather than just in time infrastructures. Collaboratively expedite plug-and-play web services without professional ideas. Synergistically provide access to open-source markets with covalent methodologies. Dynamically develop multimedia based meta-services vis-a-vis an expanded array of infrastructures. Professionally supply ubiquitous initiatives whereas cross-platform users. Phosfluorescently restore superior solutions with error-free customer service.",
    //   id: "post_9",
    //   image: photo,
    //   posting_date: "Feb 05, 2020",
    //   quote:
    //     "dolor dolores doloribus ducimus fuga iusto magni maiores minus nam numquam officiis provident quasi",
    //   short:
    //     "Treat yourself to a night relive laden age of the railway Petworth with stay at The Old Railway Station in West Sussex",
    //   title: "Create new way of manufacture",
    //   user_id: "1",
    // },
    // {
    //   category_id: 3,
    //   full:
    //     "Dynamically enhance distributed scenarios rather than extensive metrics. Compellingly supply leveraged leadership and standardized web-readiness. Phosfluorescently predominate competitive platforms after unique potentialities. Seamlessly engineer optimal niches through turnkey communities. Objectively grow emerging alignments before sticky synergy. <p> Enthusiastically e-enable inexpensive expertise for low-risk high-yield e-commerce. Monotonectally facilitate cutting-edge communities vis-a-vis process-centric systems. Competently utilize granular infomediaries with team building e-commerce. Seamlessly enable market positioning action items through optimal collaboration and idea-sharing. Dramatically revolutionize cross functional opportunities before multifunctional interfaces.<p> Uniquely pontificate e-business materials rather than seamless benefits. Completely coordinate client-centric channels for 24/365 communities. Quickly facilitate covalent interfaces after prospective vortals. Monotonectally envisioneer competitive collaboration and idea-sharing and plug-and-play systems. Energistically syndicate leading-edge initiatives vis-a-vis wireless materials. Completely initiate unique benefits via corporate core competencies. Holisticly maximize highly efficient channels without world-class partnerships. <p>Phosfluorescently brand stand-alone deliverables via premier infrastructures. Enthusiastically visualize scalable applications via market positioning web services. Phosfluorescently redefine high standards in models before emerging leadership. Energistically morph user-centric mindshare with 24/7 niches. Uniquely strategize resource maximizing outsourcing without cross functional ROI. Globally productize process-centric solutions rather than focused sources. Monotonectally repurpose bleeding-edge ideas via extensible human capital. <p>Collaboratively orchestrate covalent platforms rather than just in time infrastructures. Collaboratively expedite plug-and-play web services without professional ideas. Synergistically provide access to open-source markets with covalent methodologies. Dynamically develop multimedia based meta-services vis-a-vis an expanded array of infrastructures. Professionally supply ubiquitous initiatives whereas cross-platform users. Phosfluorescently restore superior solutions with error-free customer service.",
    //   id: "post_10",
    //   image: photo,
    //   posting_date: "Feb 04, 2020",
    //   quote:
    //     "dolor dolores doloribus ducimus fuga iusto magni maiores minus nam numquam officiis provident quasi",
    //   short:
    //     "If I have a chance to whisper the best advice to a baby and he’ll remember it for the rest of his life is this",
    //   title: "Absolute knowledge on the business line",
    //   user_id: "2",
    // },
    // {
    //   category_id: 0,
    //   full:
    //     "Dynamically enhance distributed scenarios rather than extensive metrics. Compellingly supply leveraged leadership and standardized web-readiness. Phosfluorescently predominate competitive platforms after unique potentialities. Seamlessly engineer optimal niches through turnkey communities. Objectively grow emerging alignments before sticky synergy. <p> Enthusiastically e-enable inexpensive expertise for low-risk high-yield e-commerce. Monotonectally facilitate cutting-edge communities vis-a-vis process-centric systems. Competently utilize granular infomediaries with team building e-commerce. Seamlessly enable market positioning action items through optimal collaboration and idea-sharing. Dramatically revolutionize cross functional opportunities before multifunctional interfaces.<p> Uniquely pontificate e-business materials rather than seamless benefits. Completely coordinate client-centric channels for 24/365 communities. Quickly facilitate covalent interfaces after prospective vortals. Monotonectally envisioneer competitive collaboration and idea-sharing and plug-and-play systems. Energistically syndicate leading-edge initiatives vis-a-vis wireless materials. Completely initiate unique benefits via corporate core competencies. Holisticly maximize highly efficient channels without world-class partnerships. <p>Phosfluorescently brand stand-alone deliverables via premier infrastructures. Enthusiastically visualize scalable applications via market positioning web services. Phosfluorescently redefine high standards in models before emerging leadership. Energistically morph user-centric mindshare with 24/7 niches. Uniquely strategize resource maximizing outsourcing without cross functional ROI. Globally productize process-centric solutions rather than focused sources. Monotonectally repurpose bleeding-edge ideas via extensible human capital. <p>Collaboratively orchestrate covalent platforms rather than just in time infrastructures. Collaboratively expedite plug-and-play web services without professional ideas. Synergistically provide access to open-source markets with covalent methodologies. Dynamically develop multimedia based meta-services vis-a-vis an expanded array of infrastructures. Professionally supply ubiquitous initiatives whereas cross-platform users. Phosfluorescently restore superior solutions with error-free customer service.",
    //   id: "post_11",
    //   image: photo,
    //   posting_date: "Feb 03, 2020",
    //   quote:
    //     "dolor dolores doloribus ducimus fuga iusto magni maiores minus nam numquam officiis provident quasi",
    //   short:
    //     "We have great creative team they always ready to helped you. voluptatem quiase voluptase aspernatur auted fugit",
    //   title: "Master your tools for best results",
    //   user_id: "3",
    // },
    // {
    //   category_id: 1,
    //   full:
    //     "Dynamically enhance distributed scenarios rather than extensive metrics. Compellingly supply leveraged leadership and standardized web-readiness. Phosfluorescently predominate competitive platforms after unique potentialities. Seamlessly engineer optimal niches through turnkey communities. Objectively grow emerging alignments before sticky synergy. <p> Enthusiastically e-enable inexpensive expertise for low-risk high-yield e-commerce. Monotonectally facilitate cutting-edge communities vis-a-vis process-centric systems. Competently utilize granular infomediaries with team building e-commerce. Seamlessly enable market positioning action items through optimal collaboration and idea-sharing. Dramatically revolutionize cross functional opportunities before multifunctional interfaces.<p> Uniquely pontificate e-business materials rather than seamless benefits. Completely coordinate client-centric channels for 24/365 communities. Quickly facilitate covalent interfaces after prospective vortals. Monotonectally envisioneer competitive collaboration and idea-sharing and plug-and-play systems. Energistically syndicate leading-edge initiatives vis-a-vis wireless materials. Completely initiate unique benefits via corporate core competencies. Holisticly maximize highly efficient channels without world-class partnerships. <p>Phosfluorescently brand stand-alone deliverables via premier infrastructures. Enthusiastically visualize scalable applications via market positioning web services. Phosfluorescently redefine high standards in models before emerging leadership. Energistically morph user-centric mindshare with 24/7 niches. Uniquely strategize resource maximizing outsourcing without cross functional ROI. Globally productize process-centric solutions rather than focused sources. Monotonectally repurpose bleeding-edge ideas via extensible human capital. <p>Collaboratively orchestrate covalent platforms rather than just in time infrastructures. Collaboratively expedite plug-and-play web services without professional ideas. Synergistically provide access to open-source markets with covalent methodologies. Dynamically develop multimedia based meta-services vis-a-vis an expanded array of infrastructures. Professionally supply ubiquitous initiatives whereas cross-platform users. Phosfluorescently restore superior solutions with error-free customer service.",
    //   id: "post_12",
    //   image: photo,
    //   posting_date: "Feb 02, 2020",
    //   quote:
    //     "dolor dolores doloribus ducimus fuga iusto magni maiores minus nam numquam officiis provident quasi",
    //   short:
    //     "We have great creative team they always ready to helped you. voluptatem quiase voluptase aspernatur auted fugit",
    //   title: "Making business with minimal efforts",
    //   user_id: "0",
    // },
    // {
    //   category_id: 2,
    //   full:
    //     "Dynamically enhance distributed scenarios rather than extensive metrics. Compellingly supply leveraged leadership and standardized web-readiness. Phosfluorescently predominate competitive platforms after unique potentialities. Seamlessly engineer optimal niches through turnkey communities. Objectively grow emerging alignments before sticky synergy. <p> Enthusiastically e-enable inexpensive expertise for low-risk high-yield e-commerce. Monotonectally facilitate cutting-edge communities vis-a-vis process-centric systems. Competently utilize granular infomediaries with team building e-commerce. Seamlessly enable market positioning action items through optimal collaboration and idea-sharing. Dramatically revolutionize cross functional opportunities before multifunctional interfaces.<p> Uniquely pontificate e-business materials rather than seamless benefits. Completely coordinate client-centric channels for 24/365 communities. Quickly facilitate covalent interfaces after prospective vortals. Monotonectally envisioneer competitive collaboration and idea-sharing and plug-and-play systems. Energistically syndicate leading-edge initiatives vis-a-vis wireless materials. Completely initiate unique benefits via corporate core competencies. Holisticly maximize highly efficient channels without world-class partnerships. <p>Phosfluorescently brand stand-alone deliverables via premier infrastructures. Enthusiastically visualize scalable applications via market positioning web services. Phosfluorescently redefine high standards in models before emerging leadership. Energistically morph user-centric mindshare with 24/7 niches. Uniquely strategize resource maximizing outsourcing without cross functional ROI. Globally productize process-centric solutions rather than focused sources. Monotonectally repurpose bleeding-edge ideas via extensible human capital. <p>Collaboratively orchestrate covalent platforms rather than just in time infrastructures. Collaboratively expedite plug-and-play web services without professional ideas. Synergistically provide access to open-source markets with covalent methodologies. Dynamically develop multimedia based meta-services vis-a-vis an expanded array of infrastructures. Professionally supply ubiquitous initiatives whereas cross-platform users. Phosfluorescently restore superior solutions with error-free customer service.",
    //   id: "post_13",
    //   image: photo,
    //   posting_date: "Feb 01, 2020",
    //   quote:
    //     "dolor dolores doloribus ducimus fuga iusto magni maiores minus nam numquam officiis provident quasi",
    //   short:
    //     "We have great creative team they always ready to helped you. voluptatem quiase voluptase aspernatur auted fugit",
    //   title: "Small business must evolve in big company",
    //   user_id: "1",
    // },
  ],
  pricing: [
    {
      icon:
        "https://firebasestorage.googleapis.com/v0/b/cctv-a7975.appspot.com/o/icons%2F001-money.svg?alt=media&token=50fd58f2-52ba-406d-a741-16f8294baa49",
      price: "Free",
      services: {
        avaliable: 2,
        list: [
          "Support forum",
          "Free hosting",
          "40MB of storage space",
          "Social media integration",
          "10GB of storage space",
        ],
      },
      title: "basic",
    },
    {
      icon:
        "https://firebasestorage.googleapis.com/v0/b/cctv-a7975.appspot.com/o/icons%2F003-earth-grid.svg?alt=media&token=1f7c3083-418c-4a8a-88bb-4a01416b9a38",
      price: "$17",
      services: {
        avaliable: 3,
        list: [
          "Support forum",
          "Free hosting",
          "40MB of storage space",
          "Social media integration",
          "10GB of storage space",
        ],
      },
      title: "business",
    },
    {
      icon:
        "https://firebasestorage.googleapis.com/v0/b/cctv-a7975.appspot.com/o/icons%2F006-ladder-1.svg?alt=media&token=76a4cf83-b4f6-477b-9fb4-bea757d89831",
      price: "$47",
      services: {
        avaliable: 4,
        list: [
          "Support forum",
          "Free hosting",
          "40MB of storage space",
          "Social media integration",
          "10GB of storage space",
        ],
      },
      title: "advanced",
    },
    {
      icon:
        "https://firebasestorage.googleapis.com/v0/b/cctv-a7975.appspot.com/o/icons%2F007-success-4.svg?alt=media&token=9d7b2683-90fa-41dd-ab84-2acce788c76d",
      price: "$77",
      services: {
        avaliable: 5,
        list: [
          "Support forum",
          "Free hosting",
          "40MB of storage space",
          "Social media integration",
          "10GB of storage space",
        ],
      },
      title: "elite",
    },
  ],
  process: [
    {
      text:
        "Distinctively disintermediate inexpensive e-commerce rather than orthogonal opportunities. Seamlessly deploy virtual experiences through collaborative.",
      title:
        "Collaboratively reinvent seamless methodologies through reliable data",
    },
    {
      text:
        "Intrinsicly enhance diverse niche markets with extensive deliverables. Conveniently grow user-centric architectures via pandemic web-readiness. Quickly underwhelm customized sources through interactive ideas. ",
      title: "Professionally predominate clicks-and-mortar communities",
    },
    {
      text:
        "Uniquely negotiate market positioning architectures with leading-edge services. Energistically formulate end-to-end deliverables through visionary imperatives.",
      title: "Objectively maintain sustainable infomediaries",
    },
  ],
  reviews: [
    {
      author: "Marta Kaufman",
      id: 0,
      img: photo,
      status: "CEO of General Electrics",
      text:
        "Efficiently supply dynamic methodologies after equity invested alignments. Professionally fashion adaptive initiatives after enterprise-wide methodologies. Competently recaptiualize competitive best practices for client-focused technologies. ",
      title: "BuildStars help me to grow my business beyound country limits.",
    },
    {
      author: "Robert Tompson",
      id: 1,
      img: photo,
      status: "Director of Macrosoft",
      text:
        "Rapidiously transform end-to-end strategic theme areas through functional information. Enthusiastically engage pandemic systems rather than installed base manufactured products. Quickly promote market positioning bandwidth before transparent sources. ",
      title: "Extremely good service and amazing support. Highly recommend.",
    },
    {
      author: "Edvard Wright",
      id: 2,
      img: photo,
      status: "Manager of Global Store",
      text:
        "Compellingly content architect backward-compatible models and quality communities. Professionally drive wireless benefits whereas orthogonal internal sources. Completely negotiate an expanded array of metrics and extensible interfaces. ",
      title: "Their products professional and support is personal oriented",
    },
    {
      author: "Chriss Hemsworth",
      id: 3,
      img: photo,
      status: "Customer",
      text:
        'Rapidiously syndicate professional e-services without wireless "outside the box" thinking. Distinctively seize proactive leadership via B2B alignments. Progressively myocardinate long-term high-impact manufactured products.',
      title:
        "Pretty good company in our small town. Work with respect to our needs.",
    },
  ],
  services: [
    {
      full:
        "Continually incubate standards compliant customer service rather than professional initiatives. Intrinsicly whiteboard web-enabled potentialities via team building supply chains. Collaboratively integrate granular innovation and performance based intellectual capital. Compellingly redefine multimedia based paradigms for high-quality portals. Quickly build out-of-the-box e-tailers for customer directed opportunities.",
      icon: icon,
      id: 0,
      img: photo,
      steps: [
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Construction project planning",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Monitor and coordinate all work",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Post construction phase",
        },
      ],
      subtitle: "Handling of construction materials",
      text:
        "Globally leverage existing error-free models and B2B products. Professionally productize interdependent value without bricks-and-clicks niches.",
      title: "Construction",
    },
    {
      featured: "yes",
      full:
        "Continually incubate standards compliant customer service rather than professional initiatives. Intrinsicly whiteboard web-enabled potentialities via team building supply chains. Collaboratively integrate granular innovation and performance based intellectual capital. Compellingly redefine multimedia based paradigms for high-quality portals. Quickly build out-of-the-box e-tailers for customer directed opportunities.",
      icon: icon,
      id: 1,
      img: photo,
      steps: [
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Construction project planning",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Monitor and coordinate all work",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Post construction phase",
        },
      ],
      subtitle: "Making planning for ptoject",
      text:
        "Globally leverage existing error-free models and B2B products. Professionally productize interdependent value without bricks-and-clicks niches.",
      title: "Loghistic",
    },
    {
      full:
        "Continually incubate standards compliant customer service rather than professional initiatives. Intrinsicly whiteboard web-enabled potentialities via team building supply chains. Collaboratively integrate granular innovation and performance based intellectual capital. Compellingly redefine multimedia based paradigms for high-quality portals. Quickly build out-of-the-box e-tailers for customer directed opportunities.",
      icon: icon,
      id: 2,
      img: photo,
      steps: [
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Construction project planning",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Monitor and coordinate all work",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Post construction phase",
        },
      ],
      subtitle: "Create value for future product",
      text:
        "Globally leverage existing error-free models and B2B products. Professionally productize interdependent value without bricks-and-clicks niches.",
      title: "Manufacture",
    },
    {
      full:
        "Continually incubate standards compliant customer service rather than professional initiatives. Intrinsicly whiteboard web-enabled potentialities via team building supply chains. Collaboratively integrate granular innovation and performance based intellectual capital. Compellingly redefine multimedia based paradigms for high-quality portals. Quickly build out-of-the-box e-tailers for customer directed opportunities.",
      icon: icon,
      id: 3,
      img: photo,
      steps: [
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Construction project planning",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Monitor and coordinate all work",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Post construction phase",
        },
      ],
      subtitle: "Manage workers for productive results",
      text:
        "Globally leverage existing error-free models and B2B products. Professionally productize interdependent value without bricks-and-clicks niches.",
      title: "Building",
    },
    {
      full:
        "Continually incubate standards compliant customer service rather than professional initiatives. Intrinsicly whiteboard web-enabled potentialities via team building supply chains. Collaboratively integrate granular innovation and performance based intellectual capital. Compellingly redefine multimedia based paradigms for high-quality portals. Quickly build out-of-the-box e-tailers for customer directed opportunities.",
      icon: icon,
      id: 4,
      img: photo,
      steps: [
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Construction project planning",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Monitor and coordinate all work",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Post construction phase",
        },
      ],
      subtitle: "Make connections with industry leaders",
      text:
        "Globally leverage existing error-free models and B2B products. Professionally productize interdependent value without bricks-and-clicks niches.",
      title: "Management",
    },
    {
      featured: "yes",
      full:
        "Continually incubate standards compliant customer service rather than professional initiatives. Intrinsicly whiteboard web-enabled potentialities via team building supply chains. Collaboratively integrate granular innovation and performance based intellectual capital. Compellingly redefine multimedia based paradigms for high-quality portals. Quickly build out-of-the-box e-tailers for customer directed opportunities.",
      icon: icon,
      id: 5,
      img: photo,
      steps: [
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Construction project planning",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Monitor and coordinate all work",
        },
        {
          text:
            "Competently benchmark multifunctional data with cross-unit               synergy. Synergistically incubate user-centric content rather than               2.0 paradigms. Interactively enable optimal scenarios with effective channels.",
          title: "Post construction phase",
        },
      ],
      subtitle: "Create channel of distribution",
      text:
        "Globally leverage existing error-free models and B2B products. Professionally productize interdependent value without bricks-and-clicks niches.",
      title: "Distribution",
    },
  ],
  team: [
    {
      about:
        "Professionally deploy revolutionary information rather than multimedia based channels. Continually leverage existing B2B value vis-a-vis magnetic best practices. Dynamically syndicate alternative e-services without leveraged methodologies. Intrinsicly envisioneer cutting-edge relationships for pandemic meta-services.",
      id: 0,
      img: photo,
      job: "Designer",
      name: "Martin Tompson",
      skills: [
        "Front-End: 90",
        "Wordpress: 80",
        "React Native: 70",
        "UI / UX Design: 80",
      ],
      stats: [
        {
          icon: "las la-clock",
          text: "Hours per week",
          title: "40+",
        },
        {
          icon: "las la-briefcase",
          text: "Projects completed",
          title: "170",
        },
        {
          icon: "las la-user-check",
          text: "Satisfied clients",
          title: "74",
        },
        {
          icon: "las la-trophy",
          text: "Competition winned",
          title: "140",
        },
      ],
    },
    {
      about:
        "Professionally deploy revolutionary information rather than multimedia based channels. Continually leverage existing B2B value vis-a-vis magnetic best practices. Dynamically syndicate alternative e-services without leveraged methodologies. Intrinsicly envisioneer cutting-edge relationships for pandemic meta-services.",
      id: 1,
      img: photo,
      job: "Developer",
      name: "Juliana Redford",
      skills: [
        "Front-End: 90",
        "Wordpress: 80",
        "React Native: 70",
        "UI / UX Design: 80",
      ],
      stats: [
        {
          icon: "las la-clock",
          text: "Hours per week",
          title: "40+",
        },
        {
          icon: "las la-briefcase",
          text: "Projects completed",
          title: "170",
        },
        {
          icon: "las la-user-check",
          text: "Satisfied clients",
          title: "74",
        },
        {
          icon: "las la-trophy",
          text: "Competition winned",
          title: "140",
        },
      ],
    },
    {
      about:
        "Professionally deploy revolutionary information rather than multimedia based channels. Continually leverage existing B2B value vis-a-vis magnetic best practices. Dynamically syndicate alternative e-services without leveraged methodologies. Intrinsicly envisioneer cutting-edge relationships for pandemic meta-services.",
      id: 2,
      img: photo,
      job: "CEO, Director",
      name: "Robert Ferguson",
      skills: [
        "Front-End: 90",
        "Wordpress: 80",
        "React Native: 70",
        "UI / UX Design: 80",
      ],
      stats: [
        {
          icon: "las la-clock",
          text: "Hours per week",
          title: "40+",
        },
        {
          icon: "las la-briefcase",
          text: "Projects completed",
          title: "170",
        },
        {
          icon: "las la-user-check",
          text: "Satisfied clients",
          title: "74",
        },
        {
          icon: "las la-trophy",
          text: "Competition winned",
          title: "140",
        },
      ],
    },
  ],
  users: [
    {
      about:
        "Paul R. Lawrence MBA Class of 1942 Professor of Business Administration at Harvard Business School.",
      id: 0,
      img:
        "https://hbr.org/resources/images/article_assets/2009/05/110-ranjay-gulati.jpg",
      name: "Ranjay Gulati",
    },
    {
      about: "",
      // "Efficiently visualize cutting-edge architectures vis-a-vis one-to-one collaboration and idea-sharing. Conveniently harness just in time niche markets after frictionless interfaces. Uniquely underwhelm frictionless imperatives and covalent users. Compellingly synthesize granular human capital before timely resources. ",
      id: 1,
      img:
        "https://assets.entrepreneur.com/content/1x1/300/20171011172913-Imagen1.jpeg?width=100",
      name: "G2 Consultores ",
    },
    {
      about:
        "managing director of General Catalyst and co-author of Unscaled: How AI and a New Generation of Upstarts Are Creating the Economy of the Future.",
      id: 2,
      img:
        "",
      name: "Hemant Taneja",
    },
    {
      about:
        "Efficiently visualize cutting-edge architectures vis-a-vis one-to-one collaboration and idea-sharing. Conveniently harness just in time niche markets after frictionless interfaces. Uniquely underwhelm frictionless imperatives and covalent users. Compellingly synthesize granular human capital before timely resources. ",
      id: 3,
      img:
        "https://assets.entrepreneur.com/content/1x1/300/1603747418-LogoWayraPNG.jpg?width=100",
      name: "Wayra Hispanoamérica",
    },
    {
      // about:
      //   "Efficiently visualize cutting-edge architectures vis-a-vis one-to-one collaboration and idea-sharing. Conveniently harness just in time niche markets after frictionless interfaces. Uniquely underwhelm frictionless imperatives and covalent users. Compellingly synthesize granular human capital before timely resources. ",
      id: 4,
      img:
        "https://assets.entrepreneur.com/content/1x1/300/20200226190312-Rick-Terrien-2.jpeg?width=100",
      name: "Rick Terrien",
    },
    {
      about:
        "Entrepreneur Leadership Network Contributor",
      id: 5,
      img:
        "https://assets.entrepreneur.com/content/1x1/300/1594411390-timothy-carter-profile-949x1024.jpg?width=200&crop=1:1",
      name: "Timothy Carter",
    },

  ],
  video: {
    header: "",
    about: "",
  },

  events: [
    {
      id: "event_10",
      image: "https://drive.google.com/uc?export=view&id=16TyqDZQacUom5KObCIOrkDB79SGDMfUn",
      event_date: "Feb 21,2021",
      short: "Do you want to learn about stock market, but don’t know where to start? Or want to make passive income? Going the DIY route, don't worry, we got you covered. We at Ruminate, E-Cell of IIIT Surat are pleased to announce Mr. Pranjal Kamra, a Fintech Entrepreneur, CEO of Finology Ventures Pvt. Ltd. a famous stock market analyst and an Investment and Finance Coach with 2M+ subscribers on YouTube, as our next speaker on 'Future of Stock Market and Nuances of Value Investment'. ",
      title: "Speaker Session: Future of stock market & nuances of value investing",
      rsvp_deadline: "Feb 17,2021 23:59:00",
      rsvplink: "https://docs.google.com/forms/d/e/1FAIpQLSdYmGwbqO7FdW4-xGl-D30W7gADAimt_oQ2_5f0sosaiRaz-g/viewform",
      speaker: "Mr. Pranjal Kamra"
    },
    {
      id: "event_9",
      image: "https://drive.google.com/uc?export=view&id=1w_L8wsbzqX3zYffIMShFj2S_53SxQqrC",
      event_date: "Jan 16,2021",
      short:
        "It was a 24-hour challenge where the participants had to re-brand the companies with catchy taglines that can highlight the purpose of the company concisely. This challenge discovers the creativity of the participants. Winners were decided based on the maximum number of likes on the comment.",
      title: "The Re-Brand Challenge",
      rsvp_deadline: "Feb 20,2021",
      rsvplink: "www.facebook.com"
    },
    {
      id: "event_9",
      image: "https://drive.google.com/uc?export=view&id=1kYDS58fUYRaSDBt5D4MS4__wxnI-v22a",
      event_date: "Dec 1,2020",
      short:
        "Ruminate conducted a successful survey to know the startup culture around its surroundings. The survey included questions covering the different aspects of a progressive startup-like financial, teamwork, and resources required. We tried to understand the common in all the startups and aim to help in inculcating the zeal to innovate and progress.",
      title: "Know Your Surroundings",
    },
    {
      id: "event_8",
      image: "https://drive.google.com/uc?export=view&id=1WBTyZo__kpyzT95VN2hDwl4gBImNEbNp",
      event_date: "Nov 28,2020",
      short:
        "A group discussion was conducted where the problems in Online Teaching and the possible solutions were proposed. Over 75+ students discussed the issues faced and the feasibility of various solutions. The discussion helped unravel the potential of thinking capacity, which is the key to innovation for budding entrepreneurs.",
      title: "Group Discussion - Online Teaching",
    },
    {
      id: "event_7",
      image: "https://drive.google.com/uc?export=view&id=1SmYQAwAjhRnfdLumHDKOtDnBPlK1iX0X",
      event_date: "Jan 9,2021",
      short:
        "The meeting started with an interaction of the core team with the audience, followed by a discussion on what Ruminate does and why an E-Cell is important in college. Mr. Harnish Rajput, co-founder of PiBlitz guided the audience about startups and his experience. He focused on the true meaning of startup rather than the formal definition. ",
      title: "Orientation 2021",
      speaker: "Mr. Harnish Rajput"
    },
    {
      id: "event_7",
      image: "https://drive.google.com/uc?export=view&id=1MJHmPQRRbwnAAiXA6os43cvgFfUNvrRR",
      event_date: "Nov 17,2020",
      short:
        "The session by Mr. Shakti Goap, founder of Devfolio and Fold. In the “ASK ME ANYTHING” session various questions were asked, and by answering them he laid a roadmap for sustaining a startup. He shared his experiences about utilizing college time. ",
      title: "Is College The Right Time For Startup?",
      speaker: "Mr. Shakti Goap"
    },
    {
      id: "event_6",
      image: "https://drive.google.com/uc?export=view&id=1I0cs_7cocDQ_185K-RR-DZ2GzroKYv3C",
      event_date: "Feb 15,2020",
      short:
        "The session was hosted by  Mr.Puneet Sharma, founder of BUGCLIPPER. The event witnessed a strength of over 160 students. Mr. Puneet was bombarded with many queries that students had about entrepreneurship. Hearing motivating words from one of the top entrepreneur of India made our young buds  very enthusiastic.",
      title: "What’s and How’s about Start-ups",
      speaker: "Mr. Puneet Sharma"
    },
    {
      id: "event_5",
      image: "https://drive.google.com/uc?export=view&id=14sBkgz9JAA7uLBJhoOxM3gMqLqk3TE7_",
      event_date: "Feb 10,2020",
      short:
        "National Entrepreneurship Challenge is a platform that helps colleges to build an actively functioning E-Cell. IIT Bombay gives various tasks to all registered colleges, and Ruminate's works were creative and innovative. Our team consisting of enthusiastic and hardworking members grabbed 9th position in pan India. ",
      title: "The NEC Finalists",
    },
    {
      id: "event_4",
      image: "https://drive.google.com/uc?export=view&id=1e1kRYqGjjFNh5d-F4LYCPSGNlDmhonR_",
      event_date: "Jan 25 ,2020",
      short:
        "An interactive session was held on 25th January, 2020. The budding entrepreneurs were given direction and guidance by the Senior Club Members. The event witnessed questions like how to think out of the box, how to build network among alike people, and a lot more; all the queries were resolved. Few students shared some of their innovative start-up ideas and their plans.",
      title: "Interactive Session",
    },
    {
      id: "event_3",
      image: "https://drive.google.com/uc?export=view&id=1s_ZZ2LQbA7cxA6BjQu6l_qa4Yz0i6Zvi",
      event_date: "Nov 09,2019",
      short:
        "Around 100 students participated in group discussions and were given the task to come up with ideas that could be helpful to society. This event showed their creative side and allowed them to ponder over the solutions to common problems faced by society.",
      title: "Group Discussion",
    },
    {
      id: "event_2",
      image: "https://drive.google.com/uc?export=view&id=1Y9bWxIUigluUODLqHe7Ah_DATCQYSHY7",
      event_date: "Nov 09,2019",
      short:
        "The legendary movie “ Steve Jobs ” was screened on 9th November,2019. The event witnessed 100+ budding entrepreneurs. The inspirational movie was based on the life of Steve Jobs, where the struggles and difficulties faced by him in his entrepreneurship journey were depicted.",
      title: "Movie Screening",
    },
    {
      id: "event_1",
      image: "https://drive.google.com/uc?export=view&id=1x5-YRq_Q0VGNGt7Gzy_eHdr-BZKPcjZ6",
      event_date: "Oct 31,2019",
      short:
        "An Online Competition was conducted by Ruminate wherein the students were required to submit their case studies on different aspects of entrepreneurship. We got overwhelming responses as there were around 50+ submissions on different topics. ",
      title: "Online Competition",
    },
    {
      id: "event_0",
      image: "https://drive.google.com/uc?export=view&id=11q_PaEO8ftz012leeq_gnojif6qiVIU8",
      event_date: "Oct 10,2019",
      short:
        "The first orientation of Ruminate was held on 10th october,2019. The event was attended by more than 100 students. Professor J.S Bhatt, the Director of IIIT Surat gave the message on the importance of entrepreneurship. The core idea of the E-Cell and it's vision is to support future entrepreneurs in the college was presented to the audience.",
      title: "Orientation",
      speaker: "Prof. J.S.Bhatt"
    },
  ]
};

Mock.onGet("/api/data").reply((config) => {
  const response = database;
  return [200, response];
});
